import { Component, Inject, Renderer2 } from '@angular/core';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EventService } from './services/event.service';
import { getClickId, languages } from './shared/constants/app-enums';
import { DOCUMENT, Location } from '@angular/common';

declare global {
  interface Window {
    dataLayer: any[];
  }
}
export var selectedLang: string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'best-wallet-ico';
  selectedLanguage = "en";
  linkElt: any;
  languagesList: Array<any> = languages;

  constructor(
    private eventService: EventService,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    private location: Location,
  ) {
    getClickId();
    this.eventService.getLang().subscribe((val) => {
      selectedLang = val || 'en';
    });
  }

  addHrefLang(): void {
    if(this.linkElt) this.renderer.removeChild(this.document.head, this.linkElt);
    this.linkElt = this.renderer.createElement('link');
    this.renderer.setAttribute(this.linkElt, 'rel', 'alternate');
    this.renderer.setAttribute(this.linkElt, 'hreflang', this.selectedLanguage);
    this.renderer.setAttribute(this.linkElt, 'href', window.location.href);
    this.renderer.appendChild(this.document.head, this.linkElt);
  }
}
